module.exports = __webpack_public_path__ + "img/checkmark.03de2809.svg";